import Http from "../helpers/Http";

class DeliveryService {

  getRoutes() {
    return Http.get('/routes');
  }

  getRoute(id){
    return Http.get('/routes/'  + id);
  }

  getDistribuitors(){
    return Http.post('/routes/getDistribuitors');
  }

  getPackages(data) {
    return Http.post('/routes/getPackages', data);
  }

  createRoute(data) {
    return Http.post('/routes', data);
  }
}

export default new DeliveryService();